import Axios from 'axios';
import {AxiosProcessor} from "@/shared/axios/AxiosProcessor";
import {USER_TYPE} from "@/shared/enums/UserType";
const urlEmployeeType = '/groupType';

const state = {
    employeeType: {},
    employeeTypes: [],
    employeeTypesKey: {}
};

const getters = {
    getEmployeeType: state => {
        return state.employeeType;
    },
    getEmployeeTypes: state => {
        return state.employeeTypes;
    },
    getEmployeeTypesKey: state => {
        return state.employeeTypesKey;
    }
};

const mutations = {
    setEmployeeType: (state, data) => {
        state.employeeType = data;
    },
    setEmployeeTypes: (state, data) => {
        state.employeeTypes = data;
    },
    setEmployeeTypesKey: (state, data) => {
        state.employeeTypesKey = data;
    }
};

const actions = {
    async setEmployeeType ({commit}, data) {
        //going backend
        let value = {};

        try{
            let response = {};
            if(!!!data.id) {
                response  = await Axios.post(urlEmployeeType, data);
            }
            else {
                response = await Axios.put(urlEmployeeType+'/'+ data.id, data);
            }
            value = response.data.body;
        }
        catch (e) {
            console.log('Error: ', e);
            throw e;
        }
        commit('setEmployeeType', value);
    },
    async getEmployeeType ({commit}, data) {
        let id = data.id;

        if (!id)
            throw {message: 'empty id. Please provide a valid id value'};

        /**
         * First we check the state
         * then we check the list
         * then we go to backend
         */
        if(state.employeeType.id && state.employeeType.id === id)
            return;

        let employeeType;
        let value = {};

        if (state.employeeTypes.length > 0) {
            employeeType  = state.employeeTypes.find(pat => pat.id === id);
        }

        if(employeeType)
        {
            value = employeeType;
        }
        else
        {
            let response = await AxiosProcessor.get(urlEmployeeType + '/' + id);

            if (response.Item)
                value = response.Item;
        }

        commit('setEmployeeType', value);
    },
    async getEmployeeTypes ({commit}, data){
        let value = [];
        let response = await AxiosProcessor.list(urlEmployeeType+'/types/'+USER_TYPE.EMPLOYEE, data);

        if(response.Items)
            value = response.Items;

        commit('setEmployeeTypes', value);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}